import { writable } from 'svelte/store';

export type SubscriptionStatus = 'active' | 'read_only' | 'suspended';

export interface SubscriptionInfo {
  plan: string;
  status: SubscriptionStatus;
  periodEnd: string | null;
  graceEndsAt: string | null;
  daysLeft: number | null;
  reason: string | null;
  /** Cloudflare Ray ID of the last status check (shown on the block page). */
  rayId: string | null;
}

export const SUBSCRIPTION_ERROR_CODES = ['SUBSCRIPTION_READ_ONLY', 'SUBSCRIPTION_EXPIRED', 'TENANT_SUSPENDED'];

function createSubscriptionStore() {
  const { subscribe, set } = writable<SubscriptionInfo | null>(null);

  // Plain fetch (not ApiService) so api.ts can import this store without a cycle.
  async function load() {
    try {
      const res = await fetch('/api/subscription', { credentials: 'include' });
      if (!res.ok) return;
      const body = await res.json();
      if (body?.success) set({ ...body.data, rayId: res.headers.get('cf-ray')?.split('-')[0] ?? null });
    } catch {
      // Network error: keep last known state, never block the UI on this.
    }
  }

  return { subscribe, load };
}

export const subscriptionStore = createSubscriptionStore();
